import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faGraduationCap, faHome, faTags, faList, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import colors from 'vuetify/lib/util/colors'

library.add(faEnvelope, faGraduationCap, faHome,faTags, faList, faSpinner)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Vuetify, {
    icons: {
        iconfont: 'md',
    },
})

//const opts = {}

const opts = {
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#00A500',
                //primary: 'rgb(255, 0, 0, 0.2)',
                secondary: '#00D375',
                accent: colors.shades.black,
                error: '#FFA500',
                background: '#FFD375',
            },
            dark: {
                primary: '#44A500', 
                secondary: '#00D375',
                accent: colors.shades.black,
                error: colors.red.accent3,
                background: '#FFA500',
            },
        },
        light: true,
    },
}

export default new Vuetify(opts)